__turbopack_context__.v({
  "body": "item-view-module__Uzjwcq__body",
  "container": "item-view-module__Uzjwcq__container",
  "galleryWrapper": "item-view-module__Uzjwcq__galleryWrapper",
  "image": "item-view-module__Uzjwcq__image",
  "label": "item-view-module__Uzjwcq__label",
  "sourceToggle": "item-view-module__Uzjwcq__sourceToggle",
  "wrapper": "item-view-module__Uzjwcq__wrapper",
});
